<script lang="ts" setup>
import type { FormKitFrameworkContext } from '@formkit/core'
import type { PropType } from 'vue'
import type { TLDropdownInput } from '~/types/formkit-custom'

const props = defineProps({
  context: {
    type: Object as PropType<FormKitFrameworkContext<string | string[]> & TLDropdownInput>,
    default: null
  }
})

// const
function handleInput(_name: string, value?: string) {
  if (!value) return
  if (props.context.multiple) {
    let values = [...props.context.value]
    if (values.includes(value)) {
      values = values.filter((v) => v !== value)
    } else {
      values.push(value)
    }
    props.context.node.input(values)
  } else {
    props.context.node.input(value)
  }
}

function handleReset() {
  props.context.node.input([])
}
</script>

<template>
  <CommonDropdown
    v-if="props.context.multiple === true"
    :name="props.context.node.name"
    :placeholder="props.context.placeholder"
    :options="props.context.itemOptions as string[]"
    :values="props.context.value as string[] || undefined"
    :checklist="true"
    :values-title="props.context.valuesTitle"
    :search-box="props.context.searchBox || false"
    :bottom="props.context.bottom || false"
    :limit="props.context.limit || 0"
    :add-custom="props.context.addCustom || false"
    @handle-click="handleInput"
    @handle-reset="handleReset"
  />
  <CommonDropdown
    v-else
    :name="props.context.node.name"
    :placeholder="props.context.placeholder"
    :options="props.context.itemOptions as string[]"
    :value="props.context.value"
    :values-title="props.context.valuesTitle"
    :search-box="props.context.searchBox || false"
    :bottom="props.context.bottom || false"
    :limit="props.context.limit || 0"
    @handle-click="handleInput"
    @handle-reset="handleReset"
  />
</template>

<style lang="scss"></style>
